import { render, staticRenderFns } from "./NotificationsListView.vue?vue&type=template&id=1efa5e68&scoped=true"
import script from "./NotificationsListView.vue?vue&type=script&lang=js"
export * from "./NotificationsListView.vue?vue&type=script&lang=js"
import style0 from "./NotificationsListView.vue?vue&type=style&index=0&id=1efa5e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa5e68",
  null
  
)

export default component.exports